import { BaseDto } from "./base.dto"

export class VoucherCampaignDto extends BaseDto {
  enabled: boolean
  type: string
  discount: number
  discountType: string
  minOrder: number
  maxOrder: number
  minTenant: number
  maxTenant: number
  voucherType: string
  validity: number

  static create() {
    return new VoucherCampaignDto()
  }
}

export class UpdateVoucherCampaignDto {
  discount?: number
  validity?: number
  minOrder?: number
  maxOrder?: number
  minTenant?: number
  maxTenant?: number
}